<template></template>

<script>
import { mapActions, mapState } from "vuex";
export default {
    mounted() {
        this.getPreferences();
        this.setColors();
    },
    watch: {
        parametros: function (val, old) {
            this.setColors();
        },
    },
    data: function () {
        return {
            webconfig: null,
        };
    },
    methods: {
        ...mapActions("preferencias", ["getPreferences"]),
        setColors() {
            if (Array.isArray(this.parametros)) {
                this.parametros.forEach((element) => {
                    if (element.clave == "webconfig") {
                        this.webconfig = element.valor;
                        if (this.webconfig) {
                            var root = document.querySelector(":root");
                            root.style.setProperty(
                                "--primary-color",
                                this.webconfig.color_primario
                            );
                            root.style.setProperty(
                                "--secondary-color",
                                this.webconfig.color_segundario
                            );
                            root.style.setProperty(
                                "--acent-color",
                                this.webconfig.color_seleccion
                            );
                        }
                    }
                });
            }
        },
    },
    computed: {
        ...mapState("preferencias", ["parametros"]),
    },
};
</script>
